module.exports = __webpack_public_path__ + "fonts/sourcesansprosemibold.17f83864.ttf";